<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Reset Password</h4>
                  <p>Please enter your new password.</p>
                </div>
                <span class="text-danger text-sm mt-1" v-show="errors.has('email')">{{ errors.first("email") }}</span>
                <vs-input name="email" type="email" v-validate="'required'" label-placeholder="Email"
                  v-model="resetPasswordDescription.email" class="w-full mb-6" />
                <span class="text-danger text-sm mt-1" v-show="errors.has('password')">{{ errors.first("password")
                  }}</span>
                <vs-input type="password" name="password" v-validate="'required'" ref="password"
                  label-placeholder="Password" v-model="resetPasswordDescription.password" class="w-full mb-6" />
                <span class="text-danger text-sm mt-1" v-show="errors.has('confirm_password')">{{
                  errors.first("confirm_password") }}</span>
                <vs-input type="password" name="confirm_password" v-validate="'required|confirmed:password'"
                  data-vv-as="Confirm Password" label-placeholder="Confirm Password"
                  v-model="resetPasswordDescription.confirm_password" class="w-full mb-8" />

                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                  <vs-button type="border" to="/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">Back To
                    Login</vs-button>
                  <vs-button @click.prevent="submitForm" class="w-full sm:w-auto">Reset</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";
export default {
  data() {
    return {
      resetPasswordDescription: {
        email: "",
        password: "",
        confirm_password: "",
        token: ""
      }
    };
  },
  methods: {
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.resetPassword();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    resetPassword() {
      this.$vs.loading();
      this.$store
        .dispatch("userManagement/resetPassword", this.resetPasswordDescription)
        .then(res => {
          const data = (res && res.data) ? res.data : (res || {});
          if (data && data.status === "success") {
            this.$vs.notify({
              color: "success",
              title: "Password Reset",
              text: data.message
            });

            setTimeout(() => {
              this.$vs.loading.close();
              this.$router.replace("/login");
            }, 1000);
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Password Reset",
              text: (data && data.message) || "Invalid or expired reset link"
            });
            this.$vs.loading.close();
          }
        })
        .catch(err => {
          console.log(err);
          this.$vs.loading.close();

          const is429 = (err && err.response && err.response.status === 429) || (err && err.message && err.message.includes('429'));
          const errorMessage = is429
            ? "Too many requests — please wait 60 minutes before trying again."
            : (err && err.response && err.response.data && err.response.data.message) || (err && err.message) || "Invalid or expired reset link";

          this.$vs.notify({
            color: "danger",
            title: "Password Reset",
            text: errorMessage
          });
        });
    }
  },
  mounted() {
    this.resetPasswordDescription.token = this.$route.params.token;
  },
  created() {
    // Register Module UserManagement Module
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule("userManagement", moduleUserManagement);
      moduleUserManagement.isRegistered = true;
    }
  }
};
</script>
